export default "__VITE_ASSET__4b3b707e__"